import { useTranslation } from 'react-i18next';

/**
 * Pending fallback for lazy routes. Plain text — keeps initial CSS minimal.
 */
export function PageLoading(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-full items-center justify-center text-muted-foreground">
      {t('app.loading')}
    </main>
  );
}
